import React from 'react';
import ProductSelector from '../components/ProductSelector';
import { GUARANTEE_PRODUCT_LIST } from '../constants/productFamily';
import {
  useSubscriptionProductFamily,
  useSubscriptionProductFamilyTheme,
} from '../hooks/useSubscriptionProductFamily';

const SubscriptionProductSelector = () => {
  const [selectedProduct, handleProductChange] = useSubscriptionProductFamily();
  const themeClass = useSubscriptionProductFamilyTheme();

  return (
    <ProductSelector
      products={GUARANTEE_PRODUCT_LIST}
      selectedProduct={selectedProduct}
      onProductChange={handleProductChange}
      tooltipContent='Select the product to filter subscriptions.'
      themeClass={themeClass}
    />
  );
};

export default SubscriptionProductSelector;
